<template>
  <div class="container">
    <div class="show_data_box">
      <div class="header">
        <div class="title">观众数据</div>
        <div>部分数据次日更新</div>
      </div>
      <div class="flow_list">
        <div :class="['list_item',{'active_list_item':item.id==activeAudienceId}]" v-for="item in audienceData" :key="item.id" @click="changeAudienceId(item)">
          <div class="name">{{ item.name }}</div>
          <div class="value">{{video_id==1? item.value1 :item.value2}}</div>
        </div>
      </div>
      <div class="button_box">
        <div class="left_button">
          <span :class="[{'active_span':activeTypeId==1}]">新增</span>
          <span :class="[{'active_span':activeTypeId==2}]">累计</span>

        </div>
        <div class="left_button">
          <span :class="[{'active_span':activeTypeId2==1}]">每小时</span>
          <span :class="[{'active_span':activeTypeId2==2}]">每天</span>
        </div>
      </div>
      <div class="flowEachrts" ref="flowEachartsRef"></div>
    </div>
    <div class="show_data_box">
      <div class="header">
        <div class="title">观众偏好</div>
        <div class="left_button">
          <span :class="[{'active_span':activeTypeId3==1}]" @click="getData(1)">全部</span>
          <span :class="[{'active_span':activeTypeId3==2}]" @click="getData(2)">粉丝</span>
        </div>
      </div>
      <div class="tip_list">观众兴趣</div>
      <div class="tip_box">随拍最多,相比大盘均值随拍占比更显著</div>
      <div class="flowEachrts" style="display: flex;align-items: center;justify-content: center;" v-if="video_id==2 && activeTypeId3==2">暂无数据</div>
      <div class="flowEachrts" v-else ref="audiencePreferenceRef"></div>
      <div class="AudienceLove">
        <div class="title">观众喜欢/关注的同类作者</div>
        <div v-for="item in AudienceLoveData" :key="item.name" class="item_liet">
          <div class="img_box">
            <img :src="item.url" alt="">
          </div>
          <div class="author">
            <div>{{ item.name }}</div>
            <div class="fansData">粉丝量: {{ item.fansData }}</div>
          </div>
        </div>
      </div>
      <div class="AudienceLove">
        <div class="title">观众常搜的搜索词</div>
        <div v-for="item in trendingSearchData" :key="item.name" class="search_list">
          <div class="topic_box">
            <div class="left">
              <div>{{ item.title }}</div>
              <div class="hotValue"><img src="../../assets/img/auAnalysis/hot.png" alt="">{{ item.value }}</div>
            </div>
            <div class="right">
              <img :src="item.url" alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="AudienceLove">
        <div class="title">观众喜欢的话题</div>
        <div v-for="item in AudienceTopicData" :key="item.name" class="item_list">
          <div class="img_box">
            <img :src="item.url" alt="">
          </div>
          <div class="topic_box">
            <div class="left">
              <div>{{ item.title }}</div>
              <div class="fansData">播放量 {{ item.playValue }}</div>
              <div class="hotValue"><img src="../../assets/img/auAnalysis/hot.png" alt="">{{ item.hotValue }}</div>
            </div>
            <div class="right">
              <img :src="item.img" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="view_more">
      探索更多创作灵感<i class="el-icon-arrow-right"></i>
    </div>
  </div>
</template>
    
<script>
import {
  AudienceAnalysisData,
  AudiencePreference,
  AudienceLove,
  AudienceTopic,
  trendingSearch,
} from "./js/Operatingdata";
export default {
  data() {
    return {
      audienceData: [
        {
          id: 1,
          name: "吸粉量",
          value1: "34",
          value2: "30",
          unit: "",
        },
        {
          id: 2,
          name: "吸粉率",
          value1: "0.01%",
          value2: "0.08%",
          unit: "%",
        },
        {
          id: 3,
          name: "脱粉量",
          value1: "14",
          value2: "2",
          unit: "",
        },
        {
          id: 4,
          name: "脱粉率",
          value1: "0.03%",
          value2: "0.05%",
          unit: "%",
        },
        {
          id: 5,
          name: "不感兴趣量",
          value1: "259",
          value2: "89",
          unit: "",
        },
        {
          id: 6,
          name: "不感兴趣率",
          value1: "0.06%",
          value2: "0.23%",
          unit: "%",
        },
      ],
      activeAudienceId: 1,
      video_id: this.$route.query.video_id,
      activeTypeId: 1,
      activeTypeId2: 2,
      activeTypeId3: 1, // 1全部  2粉丝
      analysisData: [],
      AudiencePreferenceData: {},
      AudienceLoveData: [],
      AudienceTopicData: [],
      trendingSearchData: [],
    };
  },
  mounted() {
    this.analysisData = AudienceAnalysisData[this.video_id - 1].analysisData;
    let obj = this.analysisData.find(
      (item) => item.id == this.activeAudienceId
    );
    this.getFlowEcharts(obj.data, 1);
    this.AudiencePreferenceData =
      AudiencePreference[this.video_id - 1].data[this.activeTypeId3 - 1];
    this.getAudienceEcharts();
    this.AudienceLoveData = AudienceLove[this.video_id - 1].data;
    this.trendingSearchData = trendingSearch[this.video_id - 1].data;
    this.AudienceTopicData = AudienceTopic[this.video_id - 1].data;
  },

  methods: {
    changeAudienceId(item) {
      this.activeAudienceId = item.id;
      let obj = this.analysisData.find(
        (item) => item.id == this.activeAudienceId
      );
      this.getFlowEcharts(obj.data, 1);
    },
    getFlowEcharts(y, type) {
      const today = new Date();
      // 生成近七日的日期数组，按从小到大排列
      const dates = [];
      for (let i = 6; i >= 0; i--) {
        const date = new Date(today);
        date.setDate(today.getDate() - i);
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        dates.push(`${month}-${day}`);
        var chart = null;
        let index = 1;
        let arrData = [];
        if (type == 1) {
          chart = this.$echarts.init(this.$refs.flowEachartsRef);
          index = this.activeAudienceId;
          arrData = this.audienceData;
        }
        let option = {
          grid: {
            left: 45,
          },
          xAxis: {
            type: "category",
            data: dates,
            boundaryGap: false,
            splitLine: {
              show: false, // 隐藏 x 轴的分隔线
            },
            axisTick: {
              show: false, // 隐藏 x 轴的刻度线（即坐标文字旁的小竖线）
            },
            axisLabel: {
              show: true, // 保留 x 轴的标签,
              color: "#999999",
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#F2F2F4", // 设置轴线颜色为红色
                type: "dashed", // 设置轴线为虚线
              },
            },
          },
          tooltip: {
            trigger: "axis",
            backgroundColor: "rgba(255,255,255,1)",
            formatter: (params) => {
              let res = `<div style="color:#666;box-shadow: 0 5px 10px 1px rgba(32, 32, 32, 0.05);padding:10px;border-radius:4px">
              <div >${params[0].axisValueLabel}<div>
                <div style="display: flex;align-items: center;margin-top: 6px;font-size:14px;"><span style="width: 10px;height: 10px;border-radius: 10px;background: #577cf7;margin-right: 5px;"></span><span style="margin-right: 10px;">${
                  arrData[index - 1].name
                }</span><span>${params[0].value}${
                arrData[index - 1].unit
              }</span><div>
              <div>`;
              return res;
            },
          },
          yAxis: {
            type: "value",
            axisLine: {
              show: false,
            },
            splitLine: {
              show: true, // 隐藏 y 轴的分隔线
              lineStyle: {
                color: "#F2F2F4", // 设置轴线颜色为红色
                type: "dashed", // 设置轴线为虚线
              },
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              show: true,
              formatter: function (value) {
                if (value >= 10000) {
                  return (value / 10000).toFixed(1) + "w";
                } else if (value >= 1000) {
                  return (value / 1000).toFixed(1) + "k";
                }
                return value + arrData[index - 1].unit;
              },
            },
            min: 0,
            max: this.video_id==1?(index == 2 ? 0.05 : index == 4 ? 0.05 : index == 6 ? 0.1 : void 0):index == 2 ? 0.1 : index == 4 ? 0.05 : index == 6 ? 0.3 : 5,
          },
          series: [
            {
              data: y,
              type: "line",
              smooth: true,
              color: "#577cf7",
              areaStyle: {
                // 设置渐变色
                color: {
                  type: "linear",
                  x: 0, // 渐变色的起始点 x 轴位置
                  y: 0, // 渐变色的起始点 y 轴位置
                  x2: 0, // 渐变色的结束点 x 轴位置
                  y2: 1, // 渐变色的结束点 y 轴位置
                  colorStops: [
                    { offset: 0, color: "rgba(0, 0, 255, 0.2)" }, // 起始颜色
                    { offset: 1, color: "rgba(0, 0, 255, 0)" }, // 结束颜色
                  ],
                  global: false, // 使用局部渐变色
                },
                origin: "start",
              },
            },
          ],
        };
        chart.setOption(option);
        window.onresize = () => {
          // 基础数据
          chart.resize();
        };
      }
    },
    getData(index) {
      this.activeTypeId3 = index;
      this.AudiencePreferenceData =
        AudiencePreference[this.video_id - 1].data[this.activeTypeId3 - 1];
      if (index == 2 && this.video_id == 2) {
        let chart = this.$echarts.init(this.$refs.audiencePreferenceRef);
        this.$echarts.dispose(chart);
      } else {
        this.$nextTick(() => {
          this.getAudienceEcharts();
        });
      }
    },
    getAudienceEcharts() {
      let chart = this.$echarts.init(this.$refs.audiencePreferenceRef);
      var xData = this.AudiencePreferenceData.xData;
      var y1Data = this.AudiencePreferenceData.y1Data;
      var y2Data = this.AudiencePreferenceData.y2Data;
      let option = {
        tooltip: {
          trigger: "axis",
          backgroundColor: "#ffffff", // 设置提示框背景颜色为白色
          textStyle: {
            color: "#666", // 设置提示框文字颜色为黑色，以保证在白色背景下可见
          },
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
        },
        legend: {
          show: true, // 显示图例
          icon: "circle", // 设置图例图标为小圆圈
          itemWidth: 8, // 设置图例图标宽度，调小图标大小
          itemHeight: 8, // 设置图例图标高度，调小图标大小
          textStyle: {
            color: "#333", // 图例文字颜色
            fontSize: 12, // 调小图例文字字体大小
          },
          bottom: 10,
          left: 6,
        },
        grid: {
          top: 20,
        },
        xAxis: {
          type: "category",
          data: xData,
          axisTick: {
            show: false, // 不显示 x 轴刻度线
          },
          axisLabel: {
            color: "#b3b3b7", // x 轴字体颜色
          },
          axisLine: {
            show: true, // 不显示 x 轴轴线
            lineStyle: {
              color: "#b3b3b7",
            },
          },
        },
        yAxis: [
          {
            type: "value",
            show: false, // 不显示 y 轴
          },
          {
            type: "value",
            show: false, // 不显示 y 轴
          },
        ],
        series: [
          {
            name: "占比",
            type: "bar",
            data: y1Data,
            yAxisIndex: 0, // 使用第一个 Y 轴
            itemStyle: {
              color: "#577cf7", // 柱状图颜色
            },
            barWidth: 20,
          },
          {
            name: "目标群体指数",
            type: "line",
            data: y2Data,
            yAxisIndex: 1, // 使用第二个 Y 轴
            itemStyle: {
              color: "#da637c", // 折线颜色
            },
            lineStyle: {
              color: "#da637c", // 折线颜色
            },
          },
        ],
      };
      chart.setOption(option);
      window.onresize = () => {
        // 基础数据
        chart.resize();
      };
    },
  },
};
</script>
    
<style scoped lang="scss">
.container {
  width: 100%;
  margin-top: 10px;
  .show_data_box {
    padding: 10px 10px;
    box-sizing: border-box;
    background: #fff;
    border-radius: 4px;
    .header {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 5px;
      .title {
        font-size: 16px;
        font-weight: 600;
      }
      .left_button {
        span {
          background: #f3f3f3;
          padding: 3px 6px;
          margin-right: 5px;
          border-radius: 4px;
          color: #999;
          cursor: pointer;
          font-weight: 600;
        }
        .active_span {
          color: #333;
        }
      }
    }

    .flow_list {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      margin-top: 10px;
      .list_item {
        width: 48%;
        background: #f7f7f8;
        padding: 10px 6px;
        box-sizing: border-box;
        border-radius: 4px;
        border: 1px solid transparent;
        cursor: pointer;
        .name {
          font-size: 13px;
          color: #999;
        }
        .value {
          font-size: 14px;
          color: 333;
          font-weight: 600;
          margin-top: 5px;
        }
      }
      .active_list_item {
        background: #f5f7fe;
        border: 1px solid #95acf9;
      }
    }
    .button_box {
      margin-top: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .left_button {
        span {
          background: #f3f3f3;
          padding: 3px 6px;
          margin-right: 5px;
          border-radius: 4px;
          color: #999;
          cursor: pointer;
        }
        .active_span {
          color: #333;
        }
      }
    }
    .flowEachrts {
      width: 100%;
      height: 300px;
    }
    .tip {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 40px;
      border-top: 1px solid #fdfdfd;
      .left {
        display: flex;
        align-items: center;
        img {
          width: 30px;
          margin-right: 2px;
        }
      }
    }
    .tip_list {
      color: #7680f6;
      font-size: 12px;
      margin-top: 6px;
    }
    .tip_box {
      font-size: 14px;
      color: #8d8e93;
      margin-top: 5px;
    }
    .AudienceLove {
      margin-top: 10px;
      border-top: 1px solid #f8f8f8;
      padding-top: 20px;
      .title {
        color: #73747a;
        font-size: 16px;
        margin-bottom: 10px;
      }
      .item_liet {
        display: flex;
        align-items: center;
        padding: 10px 0;
        .img_box {
          width: 48px;
          height: 48px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .author {
          margin-left: 10px;
          .fansData {
            margin-top: 5px;
            color: #73747a;
            font-size: 13px;
          }
        }
      }
      .item_list {
        display: flex;
        justify-content: space-between;
        padding: 10px 0;
        .img_box {
          width: 80px;
          height: 80px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .topic_box {
          flex: 1;
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-left: 10px;
          .left {
            height: 100%;
            display: flex;
            flex-direction: column;
            .fansData {
              margin-top: 5px;
              color: #73747a;
              font-size: 13px;
            }
            .hotValue {
              display: flex;
              margin-top: 10px;
              color: #73747a;
              align-items: center;
              font-size: 13px;
              img {
                width: 14px;
                margin-right: 5px;
              }
            }
          }
          .right {
            width: 90px;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
      .search_list {
        padding: 10px 0;
        .topic_box {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .left {
            height: 100%;
            display: flex;
            flex-direction: column;
            .fansData {
              margin-top: 5px;
              color: #73747a;
              font-size: 13px;
            }
            .hotValue {
              display: flex;
              margin-top: 10px;
              color: #73747a;
              align-items: center;
              font-size: 13px;
              img {
                width: 14px;
                margin-right: 5px;
              }
            }
          }
          .right {
            width: 90px;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
  }
  .view_more {
    margin: 20px 0;
    width: 100%;
    background: #fff;
    border-radius: 4px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 600;
    font-size: 15px;
    .el-icon-arrow-right {
      color: #333;
      font-weight: 600;
      font-size: 18px;
      margin-top: 2px;
    }
  }
}
</style>
    